/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useParams, useHistory, useLocation, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../@sims/@components/credit'
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Components]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Components]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/
    const { slug } = useParams();
    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useLocation]
    ----------------------------------------------------------------*/
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery(); // query.get("order_id")
    /*--------------------------------------------------------------
    [End useLocation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Nilai';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route API]
    ----------------------------------------------------------------*/
    let route_api = 'school';
    /*--------------------------------------------------------------
    [End Route API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route Path]
    ----------------------------------------------------------------*/
    let route_path = 'nilai';
    /*--------------------------------------------------------------
    [End Route Path]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'nilai';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Private]
    ----------------------------------------------------------------*/
    let PRIVATE = true;
    /*--------------------------------------------------------------
    [End Private]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);
    const [filter, set_filter] = useState(null);
    const [sub_filter, set_sub_filter] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [queue, set_queue] = useState(false)
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');
    
    const [table_height, set_table_height] = useState(0);
    
    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [end_element, set_end_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_nilai, set_data_nilai] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [no_induk, set_no_induk] = useState('')
    const [nisn, set_nisn] = useState('')
    const [nama, set_nama] = useState('')
    const [tahun_ajaran, set_tahun_ajaran] = useState('')
    const [kelas, set_kelas] = useState('')
    const [nama_penilaian, set_nama_penilaian] = useState('')
    const [sikap_spiritual_1, set_sikap_spiritual_1] = useState('-')
    const [sikap_sosial_1, set_sikap_sosial_1] = useState('-')
    const [sikap_spiritual_2, set_sikap_spiritual_2] = useState('-')
    const [sikap_sosial_2, set_sikap_sosial_2] = useState('-')
    const [data_nilai_1, set_data_nilai_1] = useState('')
    const [data_nilai_2, set_data_nilai_2] = useState('')
    const [data_nilai_ekstrakurikuler_1, set_data_nilai_ekstrakurikuler_1] = useState('')
    const [data_nilai_ekstrakurikuler_2, set_data_nilai_ekstrakurikuler_2] = useState('')
    const [sakit_1, set_sakit_1] = useState('-')
    const [izin_1, set_izin_1] = useState('-')
    const [tanpa_keterangan_1, set_tanpa_keterangan_1] = useState('-')
    const [sakit_2, set_sakit_2] = useState('-')
    const [izin_2, set_izin_2] = useState('-')
    const [tanpa_keterangan_2, set_tanpa_keterangan_2] = useState('-')
    const [keputusan_naik_kelas, set_keputusan_naik_kelas] = useState('')
    const [ke_kelas, set_ke_kelas] = useState('')
    const [tanggal, set_tanggal] = useState('')
    const [nama_wali_kelas, set_nama_wali_kelas] = useState('')
    const [nip_wali_kelas, set_nip_wali_kelas] = useState('')
    const [nama_kepala_sekolah, set_nama_kepala_sekolah] = useState('')
    const [nip_kepala_sekolah, set_nip_kepala_sekolah] = useState('')
    const [semester_ganjil, set_semester_ganjil] = useState('-')
    const [semester_genap, set_semester_genap] = useState('-')

    const [data_nilai_array_1, set_data_nilai_array_1] = useState([
        {
            id: random_character(16),
            no: '',
            mata_pelajaran : '',
            kkm_pengetahuan: '',
            nilai_pengetahuan: '',
            predikat_pengetahuan: '',
            deskripsi_pengetahuan: '',
            kkm_keterampilan: '',
            nilai_keterampilan: '',
            predikat_keterampilan: '',
            deskripsi_keterampilan: '',
            kelompok: ''
        }
    ])

    const [data_nilai_array_2, set_data_nilai_array_2] = useState([
        {
            id: random_character(16),
            no: '',
            mata_pelajaran : '',
            kkm_pengetahuan: '',
            nilai_pengetahuan: '',
            predikat_pengetahuan: '',
            deskripsi_pengetahuan: '',
            kkm_keterampilan: '',
            nilai_keterampilan: '',
            predikat_keterampilan: '',
            deskripsi_keterampilan: '',
            kelompok: ''
        }
    ])

    const [data_nilai_ekstrakurikuler_array_1, set_data_nilai_ekstrakurikuler_array_1] = useState([
        {
            id: random_character(16),
            no: '',
            nama : '',
            deskripsi: '',
        }
    ])

    const [data_nilai_ekstrakurikuler_array_2, set_data_nilai_ekstrakurikuler_array_2] = useState([
        {
            id: random_character(16),
            no: '',
            nama : '',
            deskripsi: '',
        }
    ])
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Looping Input]
    ----------------------------------------------------------------*/
    const input = [
        {
            name : "no_induk",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : "nisn",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'uppercase', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : "nama",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : "tahun_ajaran",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : "kelas",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : "nama_penilaian",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "sikap_spiritual_1",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "sikap_sosial_1",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "data_nilai_1",
            element : 'array', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "data_nilai_ekstrakurikuler_1",
            element : 'array', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "sakit_1",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "izin_1",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "tanpa_keterangan_1",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "sikap_spiritual_2",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "sikap_sosial_2",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "data_nilai_2",
            element : 'array', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "data_nilai_ekstrakurikuler_2",
            element : 'array', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "sakit_2",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "izin_2",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "tanpa_keterangan_2",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "keputusan_naik_kelas",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "ke_kelas",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "tanggal",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "nama_wali_kelas",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "nip_wali_kelas",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "nama_kepala_sekolah",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "nip_kepala_sekolah",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "semester_ganjil",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : "semester_genap",
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },

        {
            name : 'submit',
            element : 'submit',
            text_transform : 'capitalize',
            submit_file: false
        }
    ]

    const input_obj = {
        no_induk: no_induk,
        nisn: nisn,
        nama: nama,
        tahun_ajaran: tahun_ajaran,
        kelas: kelas,
        nama_penilaian: nama_penilaian,
        sikap_spiritual_1: sikap_spiritual_1,
        sikap_sosial_1: sikap_sosial_1,
        sikap_spiritual_2: sikap_spiritual_2,
        sikap_sosial_2: sikap_sosial_2,
        data_nilai_1: JSON.stringify(data_nilai_array_1),
        data_nilai_2: JSON.stringify(data_nilai_array_2),
        data_nilai_ekstrakurikuler_1: JSON.stringify(data_nilai_ekstrakurikuler_array_1),
        data_nilai_ekstrakurikuler_2: JSON.stringify(data_nilai_ekstrakurikuler_array_2),
        sakit_1: sakit_1,
        izin_1: izin_1,
        tanpa_keterangan_1: tanpa_keterangan_1,
        sakit_2: sakit_2,
        izin_2: izin_2,
        tanpa_keterangan_2: tanpa_keterangan_2,
        keputusan_naik_kelas: keputusan_naik_kelas,
        ke_kelas: ke_kelas,
        tanggal: tanggal,
        nama_wali_kelas: nama_wali_kelas,
        nip_wali_kelas: nip_wali_kelas,
        nama_kepala_sekolah: nama_kepala_sekolah,
        nip_kepala_sekolah: nip_kepala_sekolah,
        semester_ganjil: semester_ganjil,
        semester_genap: semester_genap,
    }
    /*--------------------------------------------------------------
    [End Looping input]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response ${request_params} read`, response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}

    const _search = () => {

        if(queue === true){
            return
        }
        
        if(search.length > 3){

            set_queue(true)
    
            API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response ${request_params} search`, response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_queue(false)
            })

        }

    }

    const _uploads = (action) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        
        input && input.map((x, i)=> {
            if(x.element !== 'submit' && x.element !== 'file'){
                data.append(x.name, eval(x.name))
            }
        })

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + `${route_api}/${route_path}/post__________`,
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response ${request_params} uploads`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                
                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
            set_queue(false)
		})

    }

    const _uploads_post = (params) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

		API_POST(`${route_api}/${route_path}/post__________`, {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            ...input_obj
		}).then((response) => {
            console_dev(`response ${request_params} uploads post`, response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')

                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })

                set_data_nilai_array_1([
                    {
                        id: random_character(16),
                        no: '',
                        mata_pelajaran : '',
                        kkm_pengetahuan: '',
                        nilai_pengetahuan: '',
                        predikat_pengetahuan: '',
                        deskripsi_pengetahuan: '',
                        kkm_keterampilan: '',
                        nilai_keterampilan: '',
                        predikat_keterampilan: '',
                        deskripsi_keterampilan: '',
                        kelompok: ''
                    }
                ])
            
                set_data_nilai_array_2([
                    {
                        id: random_character(16),
                        no: '',
                        mata_pelajaran : '',
                        kkm_pengetahuan: '',
                        nilai_pengetahuan: '',
                        predikat_pengetahuan: '',
                        deskripsi_pengetahuan: '',
                        kkm_keterampilan: '',
                        nilai_keterampilan: '',
                        predikat_keterampilan: '',
                        deskripsi_keterampilan: '',
                        kelompok: ''
                    }
                ])
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'connect',
        //     room: 'room_forum_user_authentication',
        //     status: 'online',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}

    const _socket_offline = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'disconnect',
        //     room: 'room_forum_user_authentication',
        //     status: 'offline',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    
    const _files_multiple = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        let data = [...event.target.files]
        
        if(data){

            console_dev('data', data)

            data.map((item, index) => {
                // console.log('item', data)
                if(item.size > 2048000){
                    return error('Ukuran File maxsimal 2MB')
                }else{
                    set_file([...data])
                }

            })

        }
        
	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            let storage_bamboo_chain = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            set_bamboo_user(storage_bamboo)
            _socket_online(STORAGE_USER[0])
            _read(1, storage_bamboo)
            
        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(PRIVATE === true){
        if(STORAGE_USER !== undefined){
            if(STORAGE_USER[0].level === 'guest'){
                history.push('/')
            }
        }else{
            history.push('/home')
            window.location.reload();
        }
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 10)
        }

    }, [data])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        if(element === 'import'){
                            set_element(null)
                        }else{
                            set_element('import')
                        }
                    }} className="_btn _cursor_pointer _push_r_m">
                        Import
                    </div>
                    <div onClick={() => {
                        if(element === 'overlay'){
                            set_element(null)
                        }else{
                            set_element('overlay')
                        }
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>

                    {
                        element === 'overlay' ?
                            <>
                                <div className="_fmc_overlay">
                                    <div className="_fmc_overlay_navbar">
                                        <div className="_row _center_align">
                                            <div className="_column">
                                                <p className="_font_size_18px">Tambah Data</p>
                                            </div>
                                            <div onClick={() => {
                                                if(element === 'overlay'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay')
                                                }
                                            }} className="_push_l_d _btn _cursor_pointer">
                                                Keluar
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_content">
                                        <div className="_container">
                                            <div className="_lily_pad_h_d">
                                                <div className="_row _push_t_g _push_b_g">
                                                    <div className="_column">
                                                        <div className="_heading_bold _push_b_l">
                                                            Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                        </div>
                                                        {
                                                            input && input.map((item, index) => (
                                                                <>
                                                                    <div key={index} className="_relative _push_b_d">
                                                                        <p style={{color: '#888', fontSize: 13, textTransform: item.text_transform}}>
                                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                            {
                                                                                item.name.replace(/_/g, " ")
                                                                            }
                                                                        </p>
                                                                        {
                                                                            item.element === 'text' ?
                                                                                <div className="_e_input">
                                                                                    <input 
                                                                                        placeholder=""
                                                                                        type={'text'} 
                                                                                        onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                                        value={eval(item.name)}
                                                                                    />
                                                                                </div>
                                                                            : item.element === 'array' ?
                                                                                item.name === 'data_nilai_1' ?
                                                                                    <>
                                                                                        <div className="_row _center_align _push_t_d">
                                                                                            <div className="_column">
                                                                                                <p>Data Nilai</p>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                                data_nilai_array_1.push(
                                                                                                    {
                                                                                                        id: random_character(16),
                                                                                                        no: '',
                                                                                                        mata_pelajaran : '',
                                                                                                        kkm_pengetahuan: '',
                                                                                                        nilai_pengetahuan: '',
                                                                                                        predikat_pengetahuan: '',
                                                                                                        deskripsi_pengetahuan: '',
                                                                                                        kkm_keterampilan: '',
                                                                                                        nilai_keterampilan: '',
                                                                                                        predikat_keterampilan: '',
                                                                                                        deskripsi_keterampilan: '',
                                                                                                        kelompok : 'A'
                                                                                                    }
                                                                                                )
                                                                                                set_refresh(random_character(16))
                                                                                            }}>
                                                                                                <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            data_nilai_array_1 && data_nilai_array_1.map((item, index) => (
                                                                                                <div key={index}>
                                                                                                    <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="No"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.no = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.no}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="_column">
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Mata Pelajaran"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.mata_pelajaran = e.target.value;
                                                                                                                        set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                    }}
                                                                                                                    value={item.mata_pelajaran}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                            set_data_nilai_array_1(data_nilai_array_1.filter(x => x.id != item.id))
                                                                                                        }}>
                                                                                                            <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_row">
                                                                                                        <div className="_colum">
                                                                                                            <p className="_push_b_m _push_t_m">Pengetahuan KI-3</p>
                                                                                                            <div className="_row _center_align">
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="KKM"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.kkm_pengetahuan = e.target.value;
                                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                            }}
                                                                                                                            value={item.kkm_pengetahuan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Nilai"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.nilai_pengetahuan = e.target.value;
                                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                            }}
                                                                                                                            value={item.nilai_pengetahuan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Predikat"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.predikat_pengetahuan = e.target.value;
                                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                            }}
                                                                                                                            value={item.predikat_pengetahuan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Deskripsi"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.deskripsi_pengetahuan = e.target.value;
                                                                                                                        set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                    }}
                                                                                                                    value={item.deskripsi_pengetahuan}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="_column">
                                                                                                            <p className="_push_b_m _push_t_m">Keterampilan KI-4</p>
                                                                                                            <div className="_row _center_align">
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="KKM"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.kkm_keterampilan = e.target.value;
                                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                            }}
                                                                                                                            value={item.kkm_keterampilan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Nilai"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.nilai_keterampilan = e.target.value;
                                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                            }}
                                                                                                                            value={item.nilai_keterampilan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Predikat"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.predikat_keterampilan = e.target.value;
                                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                            }}
                                                                                                                            value={item.predikat_keterampilan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Deskripsi"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.deskripsi_keterampilan = e.target.value;
                                                                                                                        set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                    }}
                                                                                                                    value={item.deskripsi_keterampilan}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_e_input">
                                                                                                        <input 
                                                                                                            placeholder="Kelompok (A / B)"
                                                                                                            type={'text'} 
                                                                                                            onChange={e => {
                                                                                                                item.kelompok = e.target.value;
                                                                                                                set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                            }}
                                                                                                            value={item.kelompok}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </>
                                                                                : item.name === 'data_nilai_ekstrakurikuler_1' ?
                                                                                    <>
                                                                                        <div className="_row _center_align _push_t_d">
                                                                                            <div className="_column">
                                                                                                <p>Data Nilai Ekstrakurikuler</p>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                                data_nilai_ekstrakurikuler_array_1.push(
                                                                                                    {
                                                                                                        id: random_character(16),
                                                                                                        no: '',
                                                                                                        nama : '',
                                                                                                        deskripsi: '',
                                                                                                    }
                                                                                                )
                                                                                                set_refresh(random_character(16))
                                                                                            }}>
                                                                                                <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            data_nilai_ekstrakurikuler_array_1 && data_nilai_ekstrakurikuler_array_1.map((item, index) => (
                                                                                                <div key={index}>
                                                                                                    <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="No"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.no = e.target.value;
                                                                                                                    set_data_nilai_ekstrakurikuler_array_1([...data_nilai_ekstrakurikuler_array_1]);
                                                                                                                }}
                                                                                                                value={item.no}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="_column">
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Nama Ektrakulikuler"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.nama = e.target.value;
                                                                                                                        set_data_nilai_ekstrakurikuler_array_1([...data_nilai_ekstrakurikuler_array_1]);
                                                                                                                    }}
                                                                                                                    value={item.nama}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                            set_data_nilai_ekstrakurikuler_array_1(data_nilai_array_1.filter(x => x.id != item.id))
                                                                                                        }}>
                                                                                                            <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_e_input">
                                                                                                        <input 
                                                                                                            placeholder="Deskripsi"
                                                                                                            type={'text'} 
                                                                                                            onChange={e => {
                                                                                                                item.deskripsi = e.target.value;
                                                                                                                set_data_nilai_ekstrakurikuler_array_1([...data_nilai_ekstrakurikuler_array_1]);
                                                                                                            }}
                                                                                                            value={item.deskripsi}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </>
                                                                                : item.name === 'data_nilai_2' ?
                                                                                    <>
                                                                                        <div className="_row _center_align _push_t_d">
                                                                                            <div className="_column">
                                                                                                <p>Data Nilai</p>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                                data_nilai_array_2.push(
                                                                                                    {
                                                                                                        id: random_character(16),
                                                                                                        no: '',
                                                                                                        mata_pelajaran : '',
                                                                                                        kkm_pengetahuan: '',
                                                                                                        nilai_pengetahuan: '',
                                                                                                        predikat_pengetahuan: '',
                                                                                                        deskripsi_pengetahuan: '',
                                                                                                        kkm_keterampilan: '',
                                                                                                        nilai_keterampilan: '',
                                                                                                        predikat_keterampilan: '',
                                                                                                        deskripsi_keterampilan: '',
                                                                                                        kelompok : 'A'
                                                                                                    }
                                                                                                )
                                                                                                set_refresh(random_character(16))
                                                                                            }}>
                                                                                                <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            data_nilai_array_2 && data_nilai_array_2.map((item, index) => (
                                                                                                <div key={index}>
                                                                                                    <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="No"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.no = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.no}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="_column">
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Mata Pelajaran"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.mata_pelajaran = e.target.value;
                                                                                                                        set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                    }}
                                                                                                                    value={item.mata_pelajaran}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                            set_data_nilai_array_2(data_nilai_array_2.filter(x => x.id != item.id))
                                                                                                        }}>
                                                                                                            <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_row">
                                                                                                        <div className="_colum">
                                                                                                            <p className="_push_b_m _push_t_m">Pengetahuan KI-3</p>
                                                                                                            <div className="_row _center_align">
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="KKM"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.kkm_pengetahuan = e.target.value;
                                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                            }}
                                                                                                                            value={item.kkm_pengetahuan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Nilai"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.nilai_pengetahuan = e.target.value;
                                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                            }}
                                                                                                                            value={item.nilai_pengetahuan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Predikat"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.predikat_pengetahuan = e.target.value;
                                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                            }}
                                                                                                                            value={item.predikat_pengetahuan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Deskripsi"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.deskripsi_pengetahuan = e.target.value;
                                                                                                                        set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                    }}
                                                                                                                    value={item.deskripsi_pengetahuan}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="_column">
                                                                                                            <p className="_push_b_m _push_t_m">Keterampilan KI-4</p>
                                                                                                            <div className="_row _center_align">
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="KKM"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.kkm_keterampilan = e.target.value;
                                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                            }}
                                                                                                                            value={item.kkm_keterampilan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Nilai"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.nilai_keterampilan = e.target.value;
                                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                            }}
                                                                                                                            value={item.nilai_keterampilan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="_column">
                                                                                                                    <div className="_e_input">
                                                                                                                        <input 
                                                                                                                            placeholder="Predikat"
                                                                                                                            type={'text'} 
                                                                                                                            onChange={e => {
                                                                                                                                item.predikat_keterampilan = e.target.value;
                                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                            }}
                                                                                                                            value={item.predikat_keterampilan}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Deskripsi"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.deskripsi_keterampilan = e.target.value;
                                                                                                                        set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                    }}
                                                                                                                    value={item.deskripsi_keterampilan}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_e_input">
                                                                                                        <input 
                                                                                                            placeholder="Kelompok (A / B)"
                                                                                                            type={'text'} 
                                                                                                            onChange={e => {
                                                                                                                item.kelompok = e.target.value;
                                                                                                                set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                            }}
                                                                                                            value={item.kelompok}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </>
                                                                                : item.name === 'data_nilai_ekstrakurikuler_2' ?
                                                                                    <>
                                                                                        <div className="_row _center_align _push_t_d">
                                                                                            <div className="_column">
                                                                                                <p>Data Nilai Ekstrakurikuler</p>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                                data_nilai_ekstrakurikuler_array_2.push(
                                                                                                    {
                                                                                                        id: random_character(16),
                                                                                                        no: '',
                                                                                                        nama : '',
                                                                                                        deskripsi: '',
                                                                                                    }
                                                                                                )
                                                                                                set_refresh(random_character(16))
                                                                                            }}>
                                                                                                <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            data_nilai_ekstrakurikuler_array_2 && data_nilai_ekstrakurikuler_array_2.map((item, index) => (
                                                                                                <div key={index}>
                                                                                                    <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="No"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.no = e.target.value;
                                                                                                                    set_data_nilai_ekstrakurikuler_array_2([...data_nilai_ekstrakurikuler_array_2]);
                                                                                                                }}
                                                                                                                value={item.no}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="_column">
                                                                                                            <div className="_e_input">
                                                                                                                <input 
                                                                                                                    placeholder="Nama Ektrakulikuler"
                                                                                                                    type={'text'} 
                                                                                                                    onChange={e => {
                                                                                                                        item.nama = e.target.value;
                                                                                                                        set_data_nilai_ekstrakurikuler_array_2([...data_nilai_ekstrakurikuler_array_2]);
                                                                                                                    }}
                                                                                                                    value={item.nama}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                            set_data_nilai_ekstrakurikuler_array_2(data_nilai_array_1.filter(x => x.id != item.id))
                                                                                                        }}>
                                                                                                            <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_e_input">
                                                                                                        <input 
                                                                                                            placeholder="Deskripsi"
                                                                                                            type={'text'} 
                                                                                                            onChange={e => {
                                                                                                                item.deskripsi = e.target.value;
                                                                                                                set_data_nilai_ekstrakurikuler_array_2([...data_nilai_ekstrakurikuler_array_2]);
                                                                                                            }}
                                                                                                            value={item.deskripsi}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </>
                                                                                : null
                                                                            : item.element === 'dropdown' ?                  
                                                                                <div className="_e_input">
                                                                                    <div className="_row _center_align">
                                                                                        <div className="_column">
                                                                                            <input 
                                                                                                placeholder=""
                                                                                                type={'text'} 
                                                                                                onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                                                value={eval(item.name)}
                                                                                            />
                                                                                        </div>
                                                                                        <div onClick={() => {
                                                                                            if(sub_element === item.name + index){
                                                                                                set_sub_element(null)
                                                                                            }else{
                                                                                                set_sub_element(item.name + index)
                                                                                            }
                                                                                        }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === item.name + index ? '#eee' : null}}>
                                                                                            <div className="_row _center_align">
                                                                                                <div className="_push_t_t">
                                                                                                    {
                                                                                                        sub_element === item.name + index ?
                                                                                                            <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                                        :
                                                                                                            <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="_relative">
                                                                                        {
                                                                                            sub_element === item.name + index ?
                                                                                                // _left or _right
                                                                                                <>
                                                                                                    <div className="_fmc_overlay_dropdown _right">
                                                                                                        {
                                                                                                            item.data && item.data.map((x, i) => (
                                                                                                                <div key={i} onClick={() => {eval('set_' + item.name)(x.name)}} className="_item" style={{backgroundColor: eval('set_' + item.name) === x.name ? '#eee' : null}}>{x.name}</div>
                                                                                                            ))
                                                                                                        }                                                                                                    </div>
                                                                                                </>
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            : item.element === 'money' ?
                                                                                <div className="_relative _push_b_d">
                                                                                    <p style={{color: '#888', fontSize: 13}}>
                                                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                                        Input
                                                                                    </p>
                                                                                    <div className="_e_input">
                                                                                        <div className="_row _center_align">
                                                                                            <div className="_push_r_t">
                                                                                                Rp.
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <CurrencyFormat 
                                                                                                    value={input} 
                                                                                                    thousandSeparator={true} 
                                                                                                    prefix={''}
                                                                                                    onValueChange={(e) => {
                                                                                                        if(e.value.length < 10){
                                                                                                            set_input(e.value)
                                                                                                        }else{
                                                                                                            set_input('')
                                                                                                            error('Max Length')
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            : item.element === 'file' ?
                                                                                <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                                                    <div className="_e_input">
                                                                                        <input
                                                                                            className="custom-file-input" 
                                                                                            type="file"
                                                                                            name="file"
                                                                                            placeholder=""
                                                                                            onChange={_files}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            : item.element === 'submit' ?
                                                                                <div className="_push_t_d">
                                                                                    <div onClick={() => {
                                                                                        if(item.submit_file === true){
                                                                                            _uploads(`insert_${request_params}`)
                                                                                        }else{
                                                                                            _uploads_post(`insert_${request_params}`)
                                                                                        }
                                                                                    }} className="_btn _cursor_pointer">
                                                                                        Simpan
                                                                                    </div>
                                                                                </div>
                                                                            : null
                                                                        }
                                                                    </div>
                                                                </>
                                                            ))
                                                        }
                                                    </div>
                                                    <div className="_fmc_overlay_bg_hide">
                                                        <img style={{width: 400}} src={OverlayBg}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                if(input[0].submit_file === true){
                                                    _uploads(`delete_${request_params}`)
                                                }else{
                                                    _uploads_post(`delete_${request_params}`)
                                                }
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Perbaharui Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            {
                                                input && input.map((item, index) => (
                                                    <>
                                                        <div key={index} className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13, textTransform: item.text_transform}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                {
                                                                    item.name.replace(/_/g, " ")
                                                                }
                                                            </p>
                                                            {
                                                                item.element === 'text' ?
                                                                    <div className="_e_input">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                            value={eval(item.name)}
                                                                        />
                                                                    </div>
                                                                : item.element === 'array' ?
                                                                    item.name === 'data_nilai_1' ?
                                                                        <>
                                                                            <div className="_row _center_align _push_t_d">
                                                                                <div className="_column">
                                                                                    <p>Data Nilai</p>
                                                                                </div>
                                                                                <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                    data_nilai_array_1.push(
                                                                                        {
                                                                                            id: random_character(16),
                                                                                            no: '',
                                                                                            mata_pelajaran : '',
                                                                                            kkm_pengetahuan: '',
                                                                                            nilai_pengetahuan: '',
                                                                                            predikat_pengetahuan: '',
                                                                                            deskripsi_pengetahuan: '',
                                                                                            kkm_keterampilan: '',
                                                                                            nilai_keterampilan: '',
                                                                                            predikat_keterampilan: '',
                                                                                            deskripsi_keterampilan: '',
                                                                                            kelompok : 'A'
                                                                                        }
                                                                                    )
                                                                                    set_refresh(random_character(16))
                                                                                }}>
                                                                                    <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                data_nilai_array_1 && data_nilai_array_1.map((item, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                            <div className="_e_input">
                                                                                                <input 
                                                                                                    placeholder="No"
                                                                                                    type={'text'} 
                                                                                                    onChange={e => {
                                                                                                        item.no = e.target.value;
                                                                                                        set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                    }}
                                                                                                    value={item.no}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Mata Pelajaran"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.mata_pelajaran = e.target.value;
                                                                                                            set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                        }}
                                                                                                        value={item.mata_pelajaran}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                set_data_nilai_array_1(data_nilai_array_1.filter(x => x.id != item.id))
                                                                                            }}>
                                                                                                <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="_row">
                                                                                            <div className="_colum">
                                                                                                <p className="_push_b_m _push_t_m">Pengetahuan KI-3</p>
                                                                                                <div className="_row _center_align">
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="KKM"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.kkm_pengetahuan = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.kkm_pengetahuan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Nilai"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.nilai_pengetahuan = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.nilai_pengetahuan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Predikat"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.predikat_pengetahuan = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.predikat_pengetahuan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Deskripsi"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.deskripsi_pengetahuan = e.target.value;
                                                                                                            set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                        }}
                                                                                                        value={item.deskripsi_pengetahuan}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <p className="_push_b_m _push_t_m">Keterampilan KI-4</p>
                                                                                                <div className="_row _center_align">
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="KKM"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.kkm_keterampilan = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.kkm_keterampilan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Nilai"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.nilai_keterampilan = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.nilai_keterampilan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Predikat"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.predikat_keterampilan = e.target.value;
                                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                                }}
                                                                                                                value={item.predikat_keterampilan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Deskripsi"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.deskripsi_keterampilan = e.target.value;
                                                                                                            set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                        }}
                                                                                                        value={item.deskripsi_keterampilan}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="_e_input">
                                                                                            <input 
                                                                                                placeholder="Kelompok (A / B)"
                                                                                                type={'text'} 
                                                                                                onChange={e => {
                                                                                                    item.kelompok = e.target.value;
                                                                                                    set_data_nilai_array_1([...data_nilai_array_1]);
                                                                                                }}
                                                                                                value={item.kelompok}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </>
                                                                    : item.name === 'data_nilai_ekstrakurikuler_1' ?
                                                                        <>
                                                                            <div className="_row _center_align _push_t_d">
                                                                                <div className="_column">
                                                                                    <p>Data Nilai Ekstrakurikuler</p>
                                                                                </div>
                                                                                <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                    data_nilai_ekstrakurikuler_array_1.push(
                                                                                        {
                                                                                            id: random_character(16),
                                                                                            no: '',
                                                                                            nama : '',
                                                                                            deskripsi: '',
                                                                                        }
                                                                                    )
                                                                                    set_refresh(random_character(16))
                                                                                }}>
                                                                                    <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                data_nilai_ekstrakurikuler_array_1 && data_nilai_ekstrakurikuler_array_1.map((item, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                            <div className="_e_input">
                                                                                                <input 
                                                                                                    placeholder="No"
                                                                                                    type={'text'} 
                                                                                                    onChange={e => {
                                                                                                        item.no = e.target.value;
                                                                                                        set_data_nilai_ekstrakurikuler_array_1([...data_nilai_ekstrakurikuler_array_1]);
                                                                                                    }}
                                                                                                    value={item.no}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Nama Ektrakulikuler"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.nama = e.target.value;
                                                                                                            set_data_nilai_ekstrakurikuler_array_1([...data_nilai_ekstrakurikuler_array_1]);
                                                                                                        }}
                                                                                                        value={item.nama}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                set_data_nilai_ekstrakurikuler_array_1(data_nilai_array_1.filter(x => x.id != item.id))
                                                                                            }}>
                                                                                                <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="_e_input">
                                                                                            <input 
                                                                                                placeholder="Deskripsi"
                                                                                                type={'text'} 
                                                                                                onChange={e => {
                                                                                                    item.deskripsi = e.target.value;
                                                                                                    set_data_nilai_ekstrakurikuler_array_1([...data_nilai_ekstrakurikuler_array_1]);
                                                                                                }}
                                                                                                value={item.deskripsi}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </>
                                                                    : item.name === 'data_nilai_2' ?
                                                                        <>
                                                                            <div className="_row _center_align _push_t_d">
                                                                                <div className="_column">
                                                                                    <p>Data Nilai</p>
                                                                                </div>
                                                                                <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                    data_nilai_array_2.push(
                                                                                        {
                                                                                            id: random_character(16),
                                                                                            no: '',
                                                                                            mata_pelajaran : '',
                                                                                            kkm_pengetahuan: '',
                                                                                            nilai_pengetahuan: '',
                                                                                            predikat_pengetahuan: '',
                                                                                            deskripsi_pengetahuan: '',
                                                                                            kkm_keterampilan: '',
                                                                                            nilai_keterampilan: '',
                                                                                            predikat_keterampilan: '',
                                                                                            deskripsi_keterampilan: '',
                                                                                            kelompok : 'A'
                                                                                        }
                                                                                    )
                                                                                    set_refresh(random_character(16))
                                                                                }}>
                                                                                    <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                data_nilai_array_2 && data_nilai_array_2.map((item, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                            <div className="_e_input">
                                                                                                <input 
                                                                                                    placeholder="No"
                                                                                                    type={'text'} 
                                                                                                    onChange={e => {
                                                                                                        item.no = e.target.value;
                                                                                                        set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                    }}
                                                                                                    value={item.no}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Mata Pelajaran"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.mata_pelajaran = e.target.value;
                                                                                                            set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                        }}
                                                                                                        value={item.mata_pelajaran}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                set_data_nilai_array_2(data_nilai_array_2.filter(x => x.id != item.id))
                                                                                            }}>
                                                                                                <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="_row">
                                                                                            <div className="_colum">
                                                                                                <p className="_push_b_m _push_t_m">Pengetahuan KI-3</p>
                                                                                                <div className="_row _center_align">
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="KKM"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.kkm_pengetahuan = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.kkm_pengetahuan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Nilai"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.nilai_pengetahuan = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.nilai_pengetahuan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Predikat"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.predikat_pengetahuan = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.predikat_pengetahuan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Deskripsi"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.deskripsi_pengetahuan = e.target.value;
                                                                                                            set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                        }}
                                                                                                        value={item.deskripsi_pengetahuan}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <p className="_push_b_m _push_t_m">Keterampilan KI-4</p>
                                                                                                <div className="_row _center_align">
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="KKM"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.kkm_keterampilan = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.kkm_keterampilan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Nilai"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.nilai_keterampilan = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.nilai_keterampilan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="_column">
                                                                                                        <div className="_e_input">
                                                                                                            <input 
                                                                                                                placeholder="Predikat"
                                                                                                                type={'text'} 
                                                                                                                onChange={e => {
                                                                                                                    item.predikat_keterampilan = e.target.value;
                                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                                }}
                                                                                                                value={item.predikat_keterampilan}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Deskripsi"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.deskripsi_keterampilan = e.target.value;
                                                                                                            set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                        }}
                                                                                                        value={item.deskripsi_keterampilan}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="_e_input">
                                                                                            <input 
                                                                                                placeholder="Kelompok (A / B)"
                                                                                                type={'text'} 
                                                                                                onChange={e => {
                                                                                                    item.kelompok = e.target.value;
                                                                                                    set_data_nilai_array_2([...data_nilai_array_2]);
                                                                                                }}
                                                                                                value={item.kelompok}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </>
                                                                    : item.name === 'data_nilai_ekstrakurikuler_2' ?
                                                                        <>
                                                                            <div className="_row _center_align _push_t_d">
                                                                                <div className="_column">
                                                                                    <p>Data Nilai Ekstrakurikuler</p>
                                                                                </div>
                                                                                <div className="_btn _cursor_pointer"  onClick={() => {
                                                                                    data_nilai_ekstrakurikuler_array_2.push(
                                                                                        {
                                                                                            id: random_character(16),
                                                                                            no: '',
                                                                                            nama : '',
                                                                                            deskripsi: '',
                                                                                        }
                                                                                    )
                                                                                    set_refresh(random_character(16))
                                                                                }}>
                                                                                    <ion-icon name="add-outline" style={{fontSize: 12}}></ion-icon>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                data_nilai_ekstrakurikuler_array_2 && data_nilai_ekstrakurikuler_array_2.map((item, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="_row" style={{alignItems: 'flex-end'}}>
                                                                                            <div className="_e_input">
                                                                                                <input 
                                                                                                    placeholder="No"
                                                                                                    type={'text'} 
                                                                                                    onChange={e => {
                                                                                                        item.no = e.target.value;
                                                                                                        set_data_nilai_ekstrakurikuler_array_2([...data_nilai_ekstrakurikuler_array_2]);
                                                                                                    }}
                                                                                                    value={item.no}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <div className="_e_input">
                                                                                                    <input 
                                                                                                        placeholder="Nama Ektrakulikuler"
                                                                                                        type={'text'} 
                                                                                                        onChange={e => {
                                                                                                            item.nama = e.target.value;
                                                                                                            set_data_nilai_ekstrakurikuler_array_2([...data_nilai_ekstrakurikuler_array_2]);
                                                                                                        }}
                                                                                                        value={item.nama}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="_btn _cursor_pointer" style={{height: 35}}  onClick={() => {
                                                                                                set_data_nilai_ekstrakurikuler_array_2(data_nilai_array_1.filter(x => x.id != item.id))
                                                                                            }}>
                                                                                                <ion-icon name="remove-outline" style={{fontSize: 12}}></ion-icon>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="_e_input">
                                                                                            <input 
                                                                                                placeholder="Deskripsi"
                                                                                                type={'text'} 
                                                                                                onChange={e => {
                                                                                                    item.deskripsi = e.target.value;
                                                                                                    set_data_nilai_ekstrakurikuler_array_2([...data_nilai_ekstrakurikuler_array_2]);
                                                                                                }}
                                                                                                value={item.deskripsi}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </>
                                                                    : null
                                                                : item.element === 'dropdown' ?                  
                                                                    <div className="_e_input">
                                                                        <div className="_row _center_align">
                                                                            <div className="_column">
                                                                                <input 
                                                                                    placeholder=""
                                                                                    type={'text'} 
                                                                                    onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                                    value={eval(item.name)}
                                                                                />
                                                                            </div>
                                                                            <div onClick={() => {
                                                                                if(sub_element === item.name + index){
                                                                                    set_sub_element(null)
                                                                                }else{
                                                                                    set_sub_element(item.name + index)
                                                                                }
                                                                            }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === item.name + index ? '#eee' : null}}>
                                                                                <div className="_row _center_align">
                                                                                    <div className="_push_t_t">
                                                                                        {
                                                                                            sub_element === item.name + index ?
                                                                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                            :
                                                                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="_relative">
                                                                            {
                                                                                sub_element === item.name + index ?
                                                                                    // _left or _right
                                                                                    <>
                                                                                        <div className="_fmc_overlay_dropdown _right">
                                                                                            {
                                                                                                item.data && item.data.map((x, i) => (
                                                                                                    <div key={i} onClick={() => {eval('set_' + item.name)(x.name)}} className="_item" style={{backgroundColor: eval('set_' + item.name) === x.name ? '#eee' : null}}>{x.name}</div>
                                                                                                ))
                                                                                            }                                                                                                    </div>
                                                                                    </>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                : item.element === 'money' ?
                                                                    <div className="_relative _push_b_d">
                                                                        <p style={{color: '#888', fontSize: 13}}>
                                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                            Input
                                                                        </p>
                                                                        <div className="_e_input">
                                                                            <div className="_row _center_align">
                                                                                <div className="_push_r_t">
                                                                                    Rp.
                                                                                </div>
                                                                                <div className="_column">
                                                                                    <CurrencyFormat 
                                                                                        value={input} 
                                                                                        thousandSeparator={true} 
                                                                                        prefix={''}
                                                                                        onValueChange={(e) => {
                                                                                            if(e.value.length < 10){
                                                                                                set_input(e.value)
                                                                                            }else{
                                                                                                set_input('')
                                                                                                error('Max Length')
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                : item.element === 'file' ?
                                                                    <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                                        <div className="_e_input">
                                                                            <input
                                                                                className="custom-file-input" 
                                                                                type="file"
                                                                                name="file"
                                                                                placeholder=""
                                                                                onChange={_files}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                : item.element === 'submit' ?
                                                                    <div className="_push_t_d">
                                                                        <div onClick={() => {
                                                                            if(item.submit_file === true){
                                                                                if(file === null){
                                                                                    _uploads(`update_text_${request_params}`)
                                                                                }else{
                                                                                    _uploads(`update_file_${request_params}`)
                                                                                }
                                                                            }else{
                                                                                _uploads_post(`update_${request_params}`)
                                                                            }
                                                                        }} className="_btn _cursor_pointer">
                                                                            Simpan
                                                                        </div>
                                                                    </div>
                                                                : null
                                                            }
                                                        </div>
                                                    </>
                                                ))
                                            }
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}

            {
                data_nilai ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Nilai</p>
                                </div>
                                <div onClick={() => {
                                    set_data_nilai('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>No. Induk</td>
                                                <td>{data_nilai.no_induk}</td>
                                                <td>NISN</td>
                                                <td>{data_nilai.nisn}</td>
                                            </tr>
                                            <tr>
                                                <td>Nama</td>
                                                <td>{data_nilai.nama}</td>
                                                <td>Tahun Ajaran</td>
                                                <td>{data_nilai.tahun_ajaran}</td>
                                            </tr>
                                            <tr>
                                                <td>Kelas</td>
                                                <td colSpan={3}>{data_nilai.kelas}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th colSpan={4}>A. Sikap</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Aspek</th>
                                                <th>Semester 1</th>
                                                <th>Semester 2</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>KI-1 Sikap Spiritual</td>
                                                <td>{data_nilai.sikap_spiritual_1}</td>
                                                <td>{data_nilai.sikap_sosial_1}</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>KI-2 Sikap Sosial</td>
                                                <td>{data_nilai.sikap_spiritual_2}</td>
                                                <td>{data_nilai.sikap_spiritual_2}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th colSpan={18}>B. Pengetahuan dan Keterampilan</th>
                                            </tr>
                                            <tr>
                                                <th rowSpan={3}>No</th>
                                                <th rowSpan={3}>Mata Pelajaran</th>
                                                <th colSpan={8}>Semester 1</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={4}>Pengetahuan KI-3</th>
                                                <th colSpan={4}>Keterampilan KI-4</th>
                                            </tr>
                                            <tr>
                                                <th className="_font_size_12px">KKM</th>
                                                <th className="_font_size_12px">Nilai</th>
                                                <th className="_font_size_12px">Predikat</th>
                                                <th className="_font_size_12px">Deskripsi</th>
                                                <th className="_font_size_12px">KKM</th>
                                                <th className="_font_size_12px">Nilai</th>
                                                <th className="_font_size_12px">Predikat</th>
                                                <th className="_font_size_12px">Deskripsi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>Kelompok A</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            {
                                                // console.log('-----', JSON.parse(decode(data_nilai.data_nilai_1))),
                                                JSON.parse(decode(data_nilai.data_nilai_1)).map((item, index) => {
                                                    if(item.kelompok === 'A'){
                                                        return (
                                                            <tr key={index}>
                                                                <td>{item.no}</td>
                                                                <td className="_font_size_12px">{item.mata_pelajaran}</td>
                                                                <td className="_font_size_12px">{item.kkm_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.nilai_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.predikat_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.kkm_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.nilai_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.predikat_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_keterampilan}</td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                            <tr>
                                                <td colSpan={2}>Kelompok B</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            {
                                                // console.log('-----', JSON.parse(decode(data_nilai.data_nilai_1))),
                                                JSON.parse(decode(data_nilai.data_nilai_1)).map((item, index) => {
                                                    if(item.kelompok === 'B'){
                                                        return (
                                                            <tr key={index}>
                                                                <td>{item.no}</td>
                                                                <td className="_font_size_12px">{item.mata_pelajaran}</td>
                                                                <td className="_font_size_12px">{item.kkm_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.nilai_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.predikat_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.kkm_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.nilai_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.predikat_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_keterampilan}</td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <thead>
                                            {/* <tr>
                                                <th colSpan={18}>B. Pengetahuan dan Keterampilan</th>
                                            </tr> */}
                                            <tr>
                                                <th rowSpan={3}>No</th>
                                                <th rowSpan={3}>Mata Pelajaran</th>
                                                <th colSpan={8}>Semester 2</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={4}>Pengetahuan KI-3</th>
                                                <th colSpan={4}>Keterampilan KI-4</th>
                                            </tr>
                                            <tr>
                                                <th className="_font_size_12px">KKM</th>
                                                <th className="_font_size_12px">Nilai</th>
                                                <th className="_font_size_12px">Predikat</th>
                                                <th className="_font_size_12px">Deskripsi</th>
                                                <th className="_font_size_12px">KKM</th>
                                                <th className="_font_size_12px">Nilai</th>
                                                <th className="_font_size_12px">Predikat</th>
                                                <th className="_font_size_12px">Deskripsi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>Kelompok A</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            {
                                                // console.log('-----', JSON.parse(decode(data_nilai.data_nilai_1))),
                                                JSON.parse(decode(data_nilai.data_nilai_2)).map((item, index) => {
                                                    if(item.kelompok === 'A'){
                                                        return (
                                                            <tr key={index}>
                                                                <td>{item.no}</td>
                                                                <td className="_font_size_12px">{item.mata_pelajaran}</td>
                                                                <td className="_font_size_12px">{item.kkm_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.nilai_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.predikat_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.kkm_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.nilai_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.predikat_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_keterampilan}</td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                            <tr>
                                                <td colSpan={2}>Kelompok B</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            {
                                                // console.log('-----', JSON.parse(decode(data_nilai.data_nilai_1))),
                                                JSON.parse(decode(data_nilai.data_nilai_2)).map((item, index) => {
                                                    if(item.kelompok === 'B'){
                                                        return (
                                                            <tr key={index}>
                                                                <td>{item.no}</td>
                                                                <td className="_font_size_12px">{item.mata_pelajaran}</td>
                                                                <td className="_font_size_12px">{item.kkm_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.nilai_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.predikat_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_pengetahuan}</td>
                                                                <td className="_font_size_12px">{item.kkm_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.nilai_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.predikat_keterampilan}</td>
                                                                <td className="_font_size_12px">{item.deskripsi_keterampilan}</td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th colSpan={4}>C. Kegiatan Ko dan Ekstrakurikuler</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={4}>Semester 1</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>No</td>
                                                <td>Nama Ektrakulikuler</td>
                                                <td>Deskripsi</td>
                                            </tr>
                                            {
                                                JSON.parse(decode(data_nilai.data_nilai_ekstrakurikuler_1)).map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.nama}</td>
                                                        <td>{item.deskripsi}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <thead>
                                            {/* <tr>
                                                <th colSpan={4}>C. Kegiatan Ko dan Ekstrakurikuler</th>
                                            </tr> */}
                                            <tr>
                                                <th colSpan={4}>Semester 2</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>No</td>
                                                <td>Nama Ektrakulikuler</td>
                                                <td>Deskripsi</td>
                                            </tr>
                                            {
                                                JSON.parse(decode(data_nilai.data_nilai_ekstrakurikuler_2)).map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.nama}</td>
                                                        <td>{item.deskripsi}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td rowSpan={4}>Kehadiran</td>
                                                <td colSpan={3}>Semester 1</td>
                                                <td colSpan={3}>Semester 2</td>
                                            </tr>
                                            <tr>
                                                <td>1. Sakit</td>
                                                <td style={{textAlign: 'right'}}>{data_nilai.sakit_1} Hari</td>
                                                <td></td>
                                                <td>1. Sakit</td>
                                                <td style={{textAlign: 'right'}}>{data_nilai.sakit_2} Hari</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>2. Izin</td>
                                                <td style={{textAlign: 'right'}}>{data_nilai.izin_1} Hari</td>
                                                <td></td>
                                                <td>2. Izin</td>
                                                <td style={{textAlign: 'right'}}>{data_nilai.izin_2} Hari</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>3. Tanpa Keterangan</td>
                                                <td style={{textAlign: 'right'}}>{data_nilai.tanpa_keterangan_1} Hari</td>
                                                <td></td>
                                                <td>3. Tanpa Keterangan</td>
                                                <td style={{textAlign: 'right'}}>{data_nilai.tanpa_keterangan_2} Hari</td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="_overflow_x _push_b_d">
                                <div className="_table">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td rowSpan={4}>Kenaikan</td>
                                                <td colSpan={1}>Keputusan</td>
                                                <td colSpan={2}>Naik / Tidak Naik "{data_nilai.keputusan_naik_kelas}"</td>
                                                <td>Wali Kelas</td>
                                                <td>Kepala Sekolah</td>
                                            </tr>
                                            <tr>
                                                <td rowSpan={2}>Berdasarkan hasil yang dicapai pada Semester 1 dan 2, peserta didik ditetapkan</td>
                                                <td>Ke Kelas</td>
                                                <td>{data_nilai.ke_kelas}</td>
                                                <td>-</td>
                                                <td>-</td>
                                            </tr>
                                            <tr>
                                                <td>Tanggal</td>
                                                <td>{data_nilai.tanggal}</td>
                                                <td>NIP {data_nilai.nip_wali_kelas}</td>
                                                <td>NIP {data_nilai.nip_kepala_sekolah}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {/*  Search -------------------------------------------------------------------- */}
            <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari Dengan NISN" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            {/*  End Search ---------------------------------------------------------------- */}

            {/*  Table --------------------------------------------------------------------- */}
            <div className="_data_table_transition" style={{height: table_height}}>
                <div className="_overflow_x" ref={ref_table_height}>
                    <table className="_table">
                        <thead>
                            <tr>
                                <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                                {
                                    input && input.map((x, i) => {
                                        if(x.element !== 'submit'){
                                            if(x.show_table === true){
                                                return(
                                                    <th style={{textTransform: x.text_transform}}>{x.name.replace(/_/g, " ")}</th>
                                                )
                                            }
                                        }
                                    })
                                }
                                <th>
                                    <div className="_right_text">
                                        <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data && data.list.length > 0 ? 
                                    data.list.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {/* <td>
                                                <a href={API_SERVER + '/' + item.path + '/' + item.file} target="_blank"><ion-icon name="image-outline" style={{fontSize: 22, marginBottom: -3}}></ion-icon></a>
                                            </td> */}
                                            {
                                                input && input.map((x, i) => {
                                                    if(x.element !== 'submit'){
                                                        if(x.show_table === true){
                                                            return(
                                                                <td>{eval('item.' + x.name)}</td>
                                                            )
                                                        }
                                                    }
                                                })
                                            }
                                            <td>
                                                <div className="_right_text _text_overflow">
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_delete(item.bamboo)
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Delete
                                                    </div>
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_update(item.bamboo)
                                                        // update state -------------------------
                                                        set_test(decode(item.test))
                                                        
                                                        input && input.map((x, i)=> {
                                                            if(x.element !== 'submit'){
                                                                eval('set_' + x.name)(eval('item.' + x.name)
                                                            )}
                                                        })
                                                        set_data_nilai_array_1(JSON.parse(decode(item.data_nilai_1)))
                                                        set_data_nilai_array_2(JSON.parse(decode(item.data_nilai_2)))
                                                        set_data_nilai_ekstrakurikuler_array_1(JSON.parse(decode(item.data_nilai_ekstrakurikuler_1)))
                                                        set_data_nilai_ekstrakurikuler_array_2(JSON.parse(decode(item.data_nilai_ekstrakurikuler_2)))
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Update
                                                    </div>
                                                    <div onClick={() => {
                                                        set_data_nilai(item)
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Nilai
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                :
                                    data &&
                                    <tr>
                                        <td colSpan="10">Belum Ada Data</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}

                {/* <NavLink 
                    to='/sims/export/rapor'
                    className="_btn _cursor_pointer"
                >
                    Export PDF
                </NavLink> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;